import { useEffect, useState, ComponentPropsWithoutRef } from "react";
import styled from "styled-components";
import media from "styled-media-query";

import { Player } from "@lottiefiles/react-lottie-player";
import { ColorV2 } from "@adoptaunabuelo/react-components";
import animation from "../../assets/animations/confetti.json";
import HeaderNav, { HeaderProps } from "../container/Header";
import Footer, { FooterProps } from "../container/Footer";

const screenSize1: any = "1350px";
const screenSize2: any = "1024px";

const ContainerView = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: center;
`;
const LeftViewContainer = styled.div<{ hidden?: boolean; hideMargin: boolean }>`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin-right: ${(props) => (props.hideMargin ? "0px" : "48px")};
	opacity: ${(props) => (props.hidden ? 0 : 1)};
	transition: opacity 0.6s ease-in, transform 0.6s ease-out;
	transform: ${(props) =>
		props.hidden ? "translateY(20px)" : "translateY(0px)"};
	${(props) => media.lessThan(screenSize1)`
        margin-right: ${props.hideMargin ? 0 : "8%"};
    `}
	${(props) => media.lessThan(screenSize2)`
        margin-right: ${props.hideMargin ? 0 : "5%"};
    `}
    ${media.lessThan("medium")`
        margin-right: 0px;
    `}
`;
const ConfettiView = styled.div<{ hidden?: boolean }>`
	display: flex;
	position: fixed;
	top: 0px;
	right: 0px;
	left: 0px;
	bottom: 0px;
	opacity: ${(props) => (props.hidden ? 0 : 1)};
	transition: opacity 0.6s ease-in;
`;

const Container = ({
	loading,
	headerProps,
	footerProps,
	...props
}: Props) => {
	const [activeHeader, setActiveHeader] = useState(false);
	const [show, setShow] = useState(false);
	const [showConfetti, setShowConfetti] = useState(false);
	const [hideConfetti, setHideConfetti] = useState(!props.showConfetti);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	useEffect(() => {
		setShow(false);
		setShowConfetti(false);
		delay(600).then(() => {
			setShow(true);
			setShowConfetti(true);
		});
	}, [loading]);

	const delay = (ms: number) =>
		new Promise((resolve) => setTimeout(resolve, ms));

	const handleScroll = (e: any) => {
		if (window.scrollY > 100) setActiveHeader(true);
		else setActiveHeader(false);
	};

	return (
		<ContainerView {...props}>
			<HeaderNav active={activeHeader} {...headerProps} />
			<Footer
				style={{ borderTop: "1px solid " + ColorV2.border.neutralSoft }}
				{...footerProps}
			/>
			{!hideConfetti && (
				<ConfettiView hidden={!showConfetti}>
					<Player
						style={{ width: "auto", height: "auto" }}
						loop={true}
						autoplay={true}
						src={animation}
						onEvent={(event) => {
							if (event === "loop") {
								setShowConfetti(false);
								delay(600).then(() => {
									setHideConfetti(true);
								});
							}
						}}
					/>
				</ConfettiView>
			)}

			<LeftViewContainer
				hideMargin={true}
				hidden={!show}
			>
				{props.children}
			</LeftViewContainer>
		</ContainerView>
	);
};
export default Container;
export interface Props extends ComponentPropsWithoutRef<"div"> {
	loading?: boolean;
	headerProps?: HeaderProps;
	showConfetti?: boolean;
	footerProps: FooterProps;
	contentStyle?: React.CSSProperties;
}
